import { signal } from "@preact/signals-react"
import { useEffect } from "react"
import { fetchDeviceSchemas, fetchDeviceSchemasLocal } from "../utils/api"
import { simulateAPICall } from '../utils/utils'

export const loading = signal(false)
export const error = signal(null)
export const deviceSchemas = signal([])

const fetchData = async (config, accessToken) => {

    // short-circuit if we are waiting for more parameters or already loading
    if (loading.value || !config || !accessToken) {
        return
    }

    // short-circuit if we already have the data
    if (deviceSchemas.value && deviceSchemas.value.length) {
        return
    }
    
    try {
        loading.value = true
        
        // if app config file has loadLocalComponentConfigSchema enabled, load that instead of from database. This is useful for development/debugging schema updates
        let configSchemaResult
        if (config.loadLocalDeviceProfileSchema) {
            console.log("Loading local device schemas instead of from database")
            configSchemaResult = await fetchDeviceSchemasLocal()
        }
        else {
            console.log("Loading device schemas from database")
            configSchemaResult = await fetchDeviceSchemas(config, accessToken)
        }
        deviceSchemas.value = configSchemaResult

        return deviceSchemas.value
    }
    catch(err) {
        error.value = err
        console.log(err)
    }
    finally {
        loading.value = false
    }  
    
}

export default function useDeviceSchemas(config, accessToken) {
    useEffect(() => {
        fetchData(config, accessToken)
    }, [config, accessToken])

    return {
        deviceSchemas, loading, error
    }
}